<template>
  <div class="bottom">
    <div class="card1 border">
      <p class="name">
        <span>卡库存</span>
      </p>
      <div class="card1__name">
        <div>购入</div>
        <div>划拨</div>
      </div>
      <div class="card1__table">
        <div class="fl border_right">
          <div class="card1__header">
            <span>日期</span>
            <span>数量</span>
          </div>
          <div class="table__body" v-if="card2Data.hasOwnProperty('buy') && card2Data.buy.length>0?true:false">
            <p v-for="(item,index) in card2Data.buy" :key="index">
              <span>{{item.buyTime}}</span>
              <span class="num_1">{{item.buyNumber}}</span>
            </p>
          </div>
            <span class="tips" v-else>暂无数据</span>
        </div>
        <div class="fr">
          <div class="card1__header">
            <span>日期</span>
            <span>数量</span>
          </div>
          <div class="table__body" v-if="card2Data.hasOwnProperty('transfer') && card2Data.transfer.length>0?true:false">
            <p v-for="(item,index) in card2Data.transfer" :key="index">
              <span>{{item.transferTime}}</span>
              <span class="num_2">{{item.transferNumber}}</span>
            </p>
          </div>
          <span class="tips" v-else>暂无数据</span>
        </div>
      </div>
    </div>
    <div class="card2 border">
      <p class="name">
        <span>虚拟币消耗情况</span>
      </p>
      <div class="btn">
        <span :class="{'active':btnActive === 1}" @click="btnActive = 1;type = 0">日</span>
        <span :class="{'active':btnActive === 2}" @click="btnActive = 2;type = 1">月</span>
      </div>
      <lineCharts ref="char_line" :type="type"/>
    </div>
  </div>
</template>
<script>
import lineCharts from "@/components/linecharts/linecharts"

export default {
  components:{
    lineCharts
  },
  name:"homeDown",
  data(){
    return {
      btnActive:2,
      card2Data:{},//卡库存
      type:1,       //0:日  1:月
      lineData1:[]
    }
  },
 methods:{
   //卡库存
 async simCardStocks(){
    const { data } = await this.$API.simCardStocks()
    
    this.card2Data = data
    //console.log(this.card2Data)
  },
  
  },
 
 created(){
   this.simCardStocks()
 },
 
}
</script>
<style lang="scss" scoped>
@import "../../..//public/css/mixin.scss";
.bottom{
  display: flex;
  height: 40%;
  min-height: 200px;
  justify-content: space-between;
  .name{
    text-align: center;
    >span{
      display: inline-block;
      padding: 0 20px;
      height: 31px;
      line-height: 31px;
      opacity: 1;
      background: linear-gradient(0deg,#223085 0%, #131850 100%);
      border: 1px solid #272e6d;
      font-size: 16px;
      font-family: FontName Regular, FontName Regular-Regular;
      font-weight: 400;
      color: #fefefe;
    }
  }
  >.card1{
    width: 29%;
    height: 100%;
    overflow: hidden;
    background: url("../../../assets/images/home/border4.png") no-repeat 0 0;
    background-size: 100% 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .card1__name{
      display: flex;
      justify-content: left;
      opacity: 0.85;
      flex-wrap: nowrap;
      padding: 0 20px;
      margin-top: 20px;
      margin-bottom: 2px;
      box-sizing: border-box;
      text-align: center;
      background: linear-gradient(to right,#181043 0%, #6f6c89 48%, #0f1138 100%);
      height: 40px;
      color:#FFF;
      font-size: 18px;
      line-height: 40px;
      font-weight: 600;
      >div:nth-child(1){
        border-right: 1px solid #0F1339;
        color:#FFC36E;
      }
      >div{
        color:#70C7FF;
        width: 50%;
      }
    }
    .card1__table{
      display: flex;
      flex-wrap: nowrap;
      justify-content: left;
      font-size: 14px;
      color:#FFF;
      line-height: 30px;
      text-align: center;
      min-width: 100px;
      height: calc(100% - 120px);
      .card1__header{
        display: flex;
        flex-wrap: nowrap;
        justify-content: left;
        text-align: center;
        margin-bottom: 2px;
        >span{
          display: inline-block;
          width: 50%;
        }
      }
      .border_right{
        border-right: 1px solid #0F1339;
      }
      >div{
        height: 100%;
        width: 50%;
        >.card1__header{
          background: #1B1970;
        }
        >.table__body{
          overflow: auto;
          width: 100%;
          width: 100%;
          height: calc(100% - 36px);
          @include scrollHome;
          >p:nth-child(2n){
            background: #070C36;
          }
          >p:nth-child(2n - 1){
            background: #1E2351;
          }
          >p{
            display: flex;
            flex-wrap: nowrap;
            justify-content: left;
            text-align: center;
            >span{
              display: inline-block;
              width: 50%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
         
        }
      }
      .num_1{
        color:#FFC36E;
      }
      .num_2{
        color:#70C7FF;
      }
    }
  }
  >.card2{
    width: 70%;
    height: 100%;
    background: url("../../../assets/images/home/border5.png") no-repeat 0 0;
    background-size: 100% 100%;
    position: relative;
    .btn{
      float: right;
      margin-right: 40px;
      span:nth-child(1){
        position: absolute;
        right: 60px;
        top: 20px;
      }
      span{
        text-align: center;
        padding: 4px;
        font-size: 14px;
        display: inline-block;
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 100;
        width: 38px;
        height: 16px;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
        cursor: pointer;
        background-color: transparent;
        color: #3952E5;
        border: 1px solid #223085;
      }
      .active{
        background-color: #233187;
        color: white;
      }
    }
    
  }
}
.tips{
    color: #25c1f5;
}
</style>